import styled from "styled-components";

export const PureButton = styled.button`
	border: 0;
	padding: 0;
	margin: 0;
	background: none;
	cursor: pointer;
`;

export const PrimaryButton = styled(PureButton)`
	height: 40px;
	padding: 0 16px;
	font-weight: 500;
	color: ${({theme}) => theme.secondary};
	background: ${({theme}) => theme.primary};
	box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
	border-radius: 50px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	transition: all 0.2s ease-in-out;

	&:hover:not([disabled]) {
		color: ${({theme}) => theme.primary};
		background: ${({theme}) => theme.secondary};
	}

	&:disabled {
		cursor: default;
		color: #fff;
		background: #e5e5e5;
	}
`;

export const SecondaryButton = styled.button`
	height: 40px;
	padding: 0 16px;
	font-weight: 500;
	color: ${({theme}) => theme.secondary};
	background: ${({theme}) => theme.primary};
	box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
	border: 2px solid ${({theme}) => theme.secondary};
	border-radius: 50px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	transition: all 0.2s ease-in-out;

	&:hover:not([disabled]) {
		color: ${({theme}) => theme.primary};
		background: ${({theme}) => theme.secondary};
	}

	&:disabled {
		cursor: default;
		border-color: e5e5e5;
		color: #e5e5e5;
		background: #f2f2f2;
	}
`;
